import { observer } from 'mobx-react-lite'
import { RemoveTeamMemberDialog } from '@/features/iam/teams/RemoveTeamMemberDialog'
import { type RemoveTeamMemberDialogViewModel } from './RemoveTeamMemberDialogViewModel'

export interface RemoveTeamMemberDialogContainerProps {
  vm: RemoveTeamMemberDialogViewModel
}

export const RemoveTeamMemberDialogContainer = observer(
  function RemoveTeamMemberDialogContainer({
    vm,
  }: RemoveTeamMemberDialogContainerProps) {
    return (
      <RemoveTeamMemberDialog
        showing={vm.modal.showing}
        displayName={vm.teamMember.member.displayName}
        isRemovePending={vm.remove.pending}
        onConfirm={vm.confirm}
        onDecline={vm.modal.close}
      />
    )
  },
)
